const axios = require('axios');

// const BASE_URL = 'http://prototype.koreashe.org/wp-json/wp/v2/';
// const BASE_URL2 = 'http://prototype.koreashe.org/wp-json/';
// const BASE_URL_PAGE = 'http://prototype.koreashe.org/api/';
const BASE_URL_PROD = 'https://koreashe.org/api/';
const BASE_URL_PROD2 = 'https://koreashe.org/wp-json/';

// const WPAPI = axios.create({
//   baseURL: BASE_URL,
//   timeout: 1000,
//   // headers: {'X-Custom-Header': 'foobar'}
// });

// const WPAPI2 = axios.create({
//   baseURL: BASE_URL2,
//   timeout: 1000,
//   // headers: {'X-Custom-Header': 'foobar'}
// });

// const API = axios.create({
//   baseURL: BASE_URL_PAGE,
//   timeout: 1000,
//   // headers: {'X-Custom-Header': 'foobar'}
// });

const PROD_API = axios.create({
  baseURL: BASE_URL_PROD,
  timeout: 10000,
  // headers: {'X-Custom-Header': 'foobar'}
});

const PROD_API2 = axios.create({
  baseURL: BASE_URL_PROD2,
  timeout: 10000,
  // headers: {'X-Custom-Header': 'foobar'}
});


export const getPage = (pageId:string) => {
  return PROD_API2.get(`wp/v2/pages?slug=${pageId}`)
    .then((res:any) => res.data[0]);
}

export const getPost = (postId:string) => {
  return PROD_API.get(`?mode=get_post&id=${postId}`)
    .then((res:any) => res.data);
}

export const getFormList = () => {
  return PROD_API.get(`?mode=list&type=form`)
    .then((res:any) => res.data);
}

export const postNewForm = (data:any) => {
  return PROD_API.post(`?mode=create`, data)
    .then((res:any) => res.data);
}

export const updateForm = (data:any) => {
  return PROD_API.post(`?mode=update`, data)
    .then((res:any) => res.data);
}

export const postPost = (data:any) => {
  return PROD_API.post(`?mode=create`, data)
    .then((res:any) => res.data);
}

export const getMenu = (slug:string) => {
  return PROD_API2.get(`/menus/v1/menus/${slug}`)
    .then((res:any) => res.data);
}

export const getTerms = (taxonomy:string) => {
  return PROD_API.get(`?mode=terms&taxonomy=${taxonomy}`)
  .then((res:any) => res.data);
}

export const getMainBanner = (terms: string, limit?: number) => {
  return PROD_API.get(`?mode=list&type=mainbanner&taxonomy=mainbanner_category&terms=${terms}&limit=${limit}`)
  .then((res:any) => res.data);
}

export const getPostList = (type: string, taxonomy?:string, terms?: string, limit?: number, order?: string) => {
  return PROD_API.get(`?mode=list&type=${type}${taxonomy ? `&taxonomy=${taxonomy}` : ''}${terms ? `&terms=${terms}` : ''}${limit ? `&limit=${limit}` : ''}${order ? `&order=${order}` : ''}`)
  .then((res:any) => res.data);
}

export const getMainNews = (boardId: string, limit: number) => {
  return PROD_API.get(`?mode=get_kboard_posts&limit=${limit}&board_id=${boardId}`)
  .then((res:any) => res.data);
}

export async function uploadFile(data: any) {
	const response = await PROD_API.post(
		`?mode=upload_file`,
		data,
		{
			headers: {
				'enctype': 'multipart/form-data'
			}
		}
	);
	return response.data;
}

export const postApplication = (data:any) => {
  return PROD_API.post(`?mode=create_application`, data)
    .then((res:any) => res.data);
}

export const getApplication = (postId:string, token:string) => {
  return PROD_API.get(`?mode=get_application&id=${postId}&token=${token}`)
    .then((res:any) => res.data);
}

export const getParticipation = (postSlug:string) => {
  return PROD_API.get(`?mode=get_participation&slug=${postSlug}`)
    .then((res:any) => res.data);
}

export const getSearchResult = (keyword:string, postType:string) => {
  return PROD_API.get(`?mode=search&word=${keyword}&type=${postType}&target=post&limit=10&offet=0`)
    .then((res:any) => res.data);
}

export const getActivity = (termId:string) => {
  return PROD_API.get(`?mode=list&taxonomy=activity_category&term_id=${termId}`) 
    .then((res:any) => res.data);
}

export const getBoardList = (boardId:string, limit:number, offset:number, keyword?:string, category1?: string) => {
  return PROD_API.get(`?mode=get_kboard_posts&limit=${limit}&offset=${offset}&board_id=${boardId}${keyword === undefined ? '' : `&keyword=${keyword}`}${category1 === undefined ? '' : `&category1=${category1}`}`)
    .then((res:any) => res.data);
}

export const getWPpostList = (postType:string, limit:number, offset:number, keyword?:string) => {
  return PROD_API.get(`?mode=list&like=board&limit=${limit}&offset=${offset}&type=${postType}${keyword === undefined ? '' : `&keyword=${keyword}`}`)
    .then((res:any) => res.data);
}

export const getWPpostTypeInfo = (postType:string) => {
  return PROD_API.get(`?mode=get_post_type_info&type=${postType}`)
    .then((res:any) => res.data);
}

export const getBoardPost = (postId:string) => {
  return PROD_API.get(`?mode=get_kboard_post&post_id=${postId}`)
    .then((res:any) => res.data);
}

export const getBoardPostAttached = (postId:string) => {
  return PROD_API.get(`?mode=get_kboard_post_attached&post_id=${postId}`)
    .then((res:any) => res.data);
}

export const getBoardPostOption = (postId:string) => {
  return PROD_API.get(`?mode=get_kboard_post_option&post_id=${postId}`)
    .then((res:any) => res.data);
}

export const getWPPost = (postId:string) => {
  return PROD_API.get(`?mode=get_post&id=${postId}&like=board`)
    .then((res:any) => res.data);
}

export const getWPPostAttached = (postId:string) => {
  return PROD_API.get(`?mode=get_post_attachment&id=${postId}`)
    .then((res:any) => res.data);
}

export const getBoardInfo = (boardId:string) => {
  return PROD_API.get(`?mode=get_kboard_info&board_id=${boardId}`)
    .then((res:any) => res.data);
}

export const getBoardTemplate = (boardId:string) => {
  return PROD_API.get(`?mode=get_board_template&board_id=${boardId}`)
    .then((res:any) => res.data);
}

export const getYoutubePlaylist = (playlistId:string) => {
  return PROD_API.get(`https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${playlistId}&key=AIzaSyCSu8BKzXAp9-8ddsg-MP-Q_B9FGqxcz9s`)
    .then((res:any) => res.data);
}

export const getScifourm = () => {
  return PROD_API.get(`?mode=get_scifourm`)
    .then((res:any) => res.data);
}

export const writeBoardPost = (data:any) => {
  return PROD_API.post(`?mode=write_kboard_post`, data)
    .then((res:any) => res.data);
}

export const editBoardPost = (data:any) => {
  return PROD_API.post(`?mode=edit_kboard_post`, data)
    .then((res:any) => res.data);
}

export const deleteBoardPost = (post_id:string) => {
  return PROD_API.delete(`?mode=delete_kboard_post&post_id=${post_id}`)
    .then((res:any) => res.data);
}
